import React from 'react';
import Link from '@material-ui/core/Link';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation, WithTranslation } from 'react-i18next';
// Components
import App from '../../../components/app';
// Ressources
import styles from './error404-style';
import { paths } from '../../paths';

interface Props extends WithTranslation {
    t: any;
    history?: any;
}

const ERROR_404 = [
    'Who am I? ... Error 404',
    'Sorry the page you requested cannot be found. The Aliens probably took it...',
    'Damn you found the super secret page. You better keep the secret and run',
    "I don't know who you are. I don't know what you want. If you're looking for ransom, I can tell you I don't have money... but what I do have are a very particular set of skills. Skills I have acquired over a very long career. Skills that make me a nightmare for people like you. If you let my daughter go now, that will be the end of it - I will not look for you, I will not pursue you... but if you don't, I will look for you, I will find you... and I will kill you",
    'We wants it, we needs it. Must have the precious. They stole it from us. Sneaky little hobbitses. Wicked, tricksy, false!',
    "Unicorn and now this page! You found two things that don't exist! Hope you are happy ¬_¬",
    '生きることはまことに苦しく辛い、世を呪い、人を呪い、それでも生きたい',
    '웃어라. 온 세상이 너와 함께 웃을 것이다. 울어라. 너 혼자만 울게 될 것이다',
    'Have you tried turning it off and on again?',
    "Vous savez, moi je ne crois pas qu'il y ait de bonne ou de mauvaise situation. Moi, si je devais résumer ma vie aujourd'hui avec vous, je dirais que c'est d'abord des rencontres. Des gens qui m'ont tendu la main, peut-être à un moment où je ne pouvais pas, où j'étais seul chez moi. Et c'est assez curieux de se dire que les hasards, les rencontres, forgent une destinée... Parce que quand on a le goût de la chose, quand on a le goût de la chose bien faite, le beau geste, parfois on ne trouve pas l'interlocuteur en face je dirais, le miroir qui vous aide à avancer. Alors ça n'est pas mon cas, comme je disais là, puisque moi au contraire, j'ai pu : et je dis merci à la vie, je lui dis merci, je chante la vie, je danse la vie... je ne suis qu'amour ! Et finalement, quand beaucoup de gens aujourd'hui me disent « Mais comment fais-tu pour avoir cette humanité ? », et bien je leur réponds très simplement, je leur dis que c'est ce goût de l'amour ce goût donc qui m'a poussé aujourd'hui à entreprendre une construction mécanique, mais demain qui sait ? Peut-être simplement à me mettre au service de la communauté, à faire le don, le don de soi...",
];

function Error404Page(props: Props) {
    const { t } = props;

    const [random404] = React.useState<number>(Math.floor(Math.random() * ERROR_404.length));

    function goBack(e: { preventDefault: () => void }) {
        e.preventDefault();
        props.history.goBack();
    }

    return (
        <App noFav disableBreadcrumb>
            {t('404.body')}
            <p>"{ERROR_404[random404]}"</p>
            <p>
                <Link color="secondary" href={paths.home} onClick={goBack}>
                    {t('common:back')}
                </Link>
            </p>
        </App>
    );
}

export default withStyles(styles)(withTranslation(['error', 'common'])(Error404Page));
